import history from '../../../../../history';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/FlatButton';
import {
  isInteger, isValidFileType, isValidName, isValidNameWithSpace, normalizeFax, normalizeMobile, normalizeRate, normalizeZipCode,
  renderAutoCompleteSingleSelect, renderCheckBox, renderDateField, renderTextArea, renderTextField, renderUploadField, isValidApartmentWithSpace,
} from '../../../../../components/reduxFields';
import { CancelButton, SubmitButton, SubmitButtonDisabled } from '../../../../../components/buttons';
import { change, Field, formValueSelector, reduxForm } from 'redux-form';
import moment from 'moment';
import { getAgencyDataById, getMasterData, isAgencyExist, saveAgencyData } from '../actions/AgencyAction';
import validate from './validate';
import Alert from 'react-s-alert';
import { displayCustomError, showNormalizedRate } from '../../../../../../src/actions/utilAction';
import { checkFieldExistenceInMasterDB, clearFieldErrorArray } from '../../../../../modules/AppConfig/actions';
import { MODULE } from '../constants/ApiConstants';
import GooglePlaceAutocomplete from '../../../../../components/GooglePlaceAutocomplete';

// validateIsExist = (value) => {debugger
//   if (this.Property.BusinessName === value) {
//     return 'That name already taken. Try another.';
//   } else {
//     return null;
//   }
// };

// validateRequired = (value) => !value ? 'Please enter business name' : undefined;

// const sleep = (data) => new Promise((resolve) => setTimeout(resolve, data));
// const asyncValidate = (values, dispatch) => {
//   return sleep(10000).then(() => {
//     // simulate server latency
//     if (['john', 'paul', 'george', 'ringo'].includes(values.OrganizationName)) {
//       throw { OrganizationName: 'Agency name already exist, please choose another' }
//     }
//   });
// };

const stylescss = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
};
const styles = {
  uploadButton: {
    verticalAlign: 'middle',
  },
  removeImageBtn: {
    border: 'none',
    padding: 7,
    width: 35,
    borderRadius: 54,
    marginLeft: 11,
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
};


class AgencySetup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // masterData: null,
      masterCountryList: props.master_data ? props.master_data.masterCountry : [],
      masterStateList: props.master_data ? props.master_data.masterState : [],
      filteredStatesByCountry: [],
      DatabaseNameList: props.organizationDatabase,
      titlePrefixList: [{ id: 1, value: 'Mr.' }, { id: 2, value: 'Mrs.' }],
      subscriptionPlanTypes: [{ id: 1, value: 'Weekly' }, { id: 2, value: 'Monthly' }, { id: 3, value: 'Yearly' }],
      // agencyData: props.agencyData,
      agencyId: null,
      subscriptionPlanId: null,
      smtpId: null,
      StartDate: null,
      Status: null,
      imageLogoPreviewUrl: '',
      LogoImage: '',
      imageFaviconPreviewUrl: '',
      FaviconImage: '',
      isAgencyExist: false,
      // showPassword: false,
      street_number: '',
      route: '',
      locality: '',
      // administrative_area_level_1: '',
      // country: '',
      postal_code: '',
      latitude: 0.0,
      longitude: 0.0,
      apartmentNumber: '',
      isValidAddress: true,
      Address1: null,
      payrollStartWeekDay: [{ id: 'Sunday', value: 'Sunday' }, { id: 'Monday', value: 'Monday' }, { id: 'Tuesday', value: 'Tuesday' },
        { id: 'Wednesday', value: 'Wednesday' }, { id: 'Thursday', value: 'Thursday' }, { id: 'Friday', value: 'Friday' }, { id: 'Saturday', value: 'Saturday' }],
      payrollEndWeekDay: [{ id: 'Sunday', value: 'Sunday' }, { id: 'Monday', value: 'Monday' }, { id: 'Tuesday', value: 'Tuesday' },
        { id: 'Wednesday', value: 'Wednesday' }, { id: 'Thursday', value: 'Thursday' }, { id: 'Friday', value: 'Friday' }, { id: 'Saturday', value: 'Saturday' }],
    };
    this.handleCancel = this.handleCancel.bind(this);
    this.checkBusinessName = this.checkBusinessName.bind(this);
    this.GetFullAddress = this.GetFullAddress.bind(this);
    this.IsFullAddressEmpty = this.IsFullAddressEmpty.bind(this); 
  }


  componentWillMount() {
    this.props.getMasterData('ORGANIZATIONDATABASEDETAIL');
    if (this.props.match.params && this.props.match.params.id) {
      this.setState({ agencyId: this.props.match.params.id }, () => {
        this.props.getAgencyDataById(this.state.agencyId);
      });
    }
    // this.getFilteredStatesList(1);
  }

  IsFullAddressEmpty(searchText)
  {
    if(searchText.length === 0)
      this.setState({isValidAddress: false});    
  }

  GetFullAddress(componentForm) {
    this.setState({
      street_number: componentForm.street_number,
      route: componentForm.route,
      locality: componentForm.locality,
      // administrative_area_level_1: componentForm.administrative_area_level_1,
      // country: componentForm.country,
      postal_code: componentForm.postal_code,
      latitude: componentForm.lat,
      longitude: componentForm.lng,
      isValidAddress: true,
    }, () => {
      this.props.dispatch(change('AgencySetupForm', 'City', this.state.locality === 'long_name' ? '' : this.state.locality));
      this.props.dispatch(change('AgencySetupForm', 'Zip', this.state.postal_code === 'short_name' ? '' : this.state.postal_code));
      let Address1 = this.state.street_number === 'short_name' && this.state.route === 'long_name' ? '' :
        this.state.street_number === 'short_name' ? this.state.route : this.state.street_number + ' ' + this.state.route;
      this.setState({ Address1: Address1 });
    });
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps);
    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      let masterData = nextProps.master_data;
      let orgDb = [];
      if (masterData.organizationDatabaseDetail && masterData.organizationDatabaseDetail.length) {
        orgDb = masterData.organizationDatabaseDetail.map((Obj) => {
          return {
            'id': Obj.id,
            'value': Obj.databaseName,
          };
        });
      }
      this.setState({
        masterCountryList: masterData.masterCountry,
        masterStateList: masterData.masterState,
        DatabaseNameList: orgDb,
      });
    }
    if (nextProps.agencyData && nextProps.agencyData !== this.props.agencyData) {
      if (nextProps.agencyData.id) {
        let subscriptionPlanData = nextProps.agencyData.organizationSubscriptionPlans.length ? nextProps.agencyData.organizationSubscriptionPlans[0] : {};
        let smtpData = nextProps.agencyData.organizationSMTPDetail.length ? nextProps.agencyData.organizationSMTPDetail[0] : {};
        let startDate = subscriptionPlanData.startDate ? subscriptionPlanData.startDate : null;
        let logoUrl = nextProps.agencyData.logo ? nextProps.agencyData.logo : '';
        let faviconUrl = nextProps.agencyData.favicon ? nextProps.agencyData.favicon : '';

        this.setState({
          StartDate: startDate,
          imageLogoPreviewUrl: logoUrl,
          imageFaviconPreviewUrl: faviconUrl,
          subscriptionPlanId: subscriptionPlanData.id,
          smtpId: smtpData.id,
        });
        // this.getFilteredStatesList(nextProps.agencyData.countryID);
      }
    }

    // console.log('nextProps.agencyData..............',nextProps.agencyData, this.props.agencyData)
    if (nextProps.agencyData && nextProps.agencyData !== this.props.agencyData) {
      this.setState({
        Address1: nextProps.agencyData && nextProps.agencyData.address1 ? nextProps.agencyData.address1 : '',
        latitude: nextProps.agencyData && nextProps.agencyData.latitude ? nextProps.agencyData.latitude : 0.0,
        longitude: nextProps.agencyData && nextProps.agencyData.longitude ? nextProps.agencyData.longitude : 0.0,
      });
    }

    if (nextProps.is_agency_exist && this.props.is_agency_exist !== nextProps.is_agency_exist) {
      this.setState({ isAgencyExist: nextProps.is_agency_exist.data });
      if (nextProps.is_agency_exist.data) {
        window.setTimeout(function() {
          document.getElementById('businessName').focus();
        }, 0);
      }
    }

    // if (nextProps.initialValues && nextProps.initialValues.Address1 !== this.props.initialValues.Address1) {
    //   document.getElementById('Address1').value = nextProps.initialValues.Address1;
    // }
  }

  handleCancel() {
    this.props.clearFieldErrorArray();
    history.push('/webadmin/agency');
  }

  _handleImageChange(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    /* if (!this.isValidFileType(file.name, 'image')) {
          // console.log('Please select a valid image');
          // this.setState({ validImageError: 'only jpeg, jpg, gif, bmp, png image type allowed.' });
    }*/
    reader.onloadend = () => {
      let ImageBytes = reader.result;
      if (e.target.name === 'Logo') {
        this.setState({
          imageLogoPreviewUrl: ImageBytes,
          LogoImage: e.target.files[0].name,
        });
      } else {
        this.setState({
          imageFaviconPreviewUrl: ImageBytes,
          FaviconImage: e.target.files[0].name,
        });
      }
      // console.log('this.state.imageFrontPreviewUrl: ', this.state.imageFrontPreviewUrl.length);
      // console.log('this.state.imageBackPreviewUrl: ', this.state.imageBackPreviewUrl.length);
    };
    if (file) {
      let isValidTypeImage = isValidFileType(file.name, 'image');
      if (!isValidTypeImage) {
        Alert.warning('Please select a valid type image', {
          position: 'bottom-right',
          effect: 'slide',
        });
      } else {
        Alert.closeAll();
        reader.readAsDataURL(file);
      }
      // e.target.value = null;
    }
  }

  handleRemoveImage = (e, type) => {
    e.preventDefault();
    if (type === 'logo') {
      this.setState({ imageLogoPreviewUrl: '' });
    } else if (type === 'favicon') {
      this.setState({ imageFaviconPreviewUrl: '' });
    }
  };

  onDateChange = (input, value) => {
    // console.log('date change ....', input, value);
    input.onChange(moment(value).format());
    this.setState({
      [input.name]: value,
    });
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    // if (input.name === 'PayrollStartWeekDay') {
    //   this.setState({
    //     PayrollEndWeekDay :
    //   });
    let requiredDay = null;
    switch (selectedRecord.value) {
    case 'Sunday':
      requiredDay = 'Saturday';
      break;
    case 'Monday':
      requiredDay = 'Sunday';
      break;
    case 'Tuesday':
      requiredDay = 'Monday';
      break;
    case 'Wednesday':
      requiredDay = 'Tuesday';
      break;
    case 'Thursday':
      requiredDay = 'Wednesday';
      break;
    case 'Friday':
      requiredDay = 'Thursday';
      break;
    case 'Saturday':
      requiredDay = 'Friday';
      break;
    }
    this.props.dispatch(change('AgencySetupForm', 'PayrollEndWeekDay', requiredDay));
  }

  // getFilteredStatesList = (countryID) => {
  //   this.setState((prevState, props) => {
  //     let allStates = this.state.masterStateList;
  //     let filteredStates = allStates.filter((Obj) => Obj.countryID === countryID);
  //     return {
  //       filteredStatesByCountry: filteredStates,
  //     };
  //   });
  // }

  checkBusinessName(event, value) {
    if (value.length) {
      this.props.isAgencyExist(value);
    } else {
      this.setState({ isAgencyExist: false });
    }
  }
  /** *******************     Input field exist check        ***********************/
  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': (this.props.initialValues && this.props.initialValues.id) ? this.props.initialValues.id : 0,
      };
      this.props.checkFieldExistenceInMasterDB(postData);
    }
  };
  /** *****   End Input field exist check    **********/
  onSubmitHandler(formProps) {
    //  console.log('this.state.Address1...........',this.state.Address1);
    if (this.state.Address1 === null || this.state.Address1 === '') {
      this.setState({ isValidAddress: false });
      return null;
    }

    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) {
      ;// Avoid Submit if field error checking
      return null;
    }
    let formData = {
      'id': this.state.agencyId ? this.state.agencyId : 0,
      'OrganizationName': formProps.OrganizationName,
      'BusinessName': formProps.BusinessName,
      'Description': formProps.Description,
      // 'Address1': formProps.Address1,
      'Address1': this.state.Address1,
      // 'Address1': document.getElementById('Address1').value,
      'City': formProps.City,
      // 'StateID': formProps.StateID,
      'Zip': formProps.Zip,
      'Phone': formProps.Phone,
      // 'CountryID': formProps.CountryID,
      'Fax': formProps.Fax,
      'Email': formProps.Email,
      'LogoBase64': this.state.imageLogoPreviewUrl,
      'FaviconBase64': this.state.imageFaviconPreviewUrl,
      'ContactPersonFirstName': formProps.ContactPersonFirstName,
      'ContactPersonMiddleName': formProps.ContactPersonMiddleName,
      'ContactPersonLastName': formProps.ContactPersonLastName,
      // 'ContactPersonMaritalStatus': formProps.ContactPersonMaritalStatus,
      'ContactPersonPhoneNumber': formProps.ContactPersonPhoneNumber,
      'UserName': formProps.UserName,
      'Password': formProps.Password,
      'DatabaseDetailId': this.state.agencyId ? this.props.agencyData.databaseDetailId : formProps.DatabaseDetailId,
      'IsActive': formProps.IsActive ? true : false,
      'Latitude': this.state.latitude,
      'Longitude': this.state.longitude,
      'ApartmentNumber': formProps.ApartmentNumber,
      'VendorIdDirect': formProps.VendorIdDirect,
      'VendorIdIndirect': formProps.VendorIdIndirect,
      'VendorNameDirect': formProps.VendorNameDirect,
      'VendorNameIndirect': formProps.VendorNameIndirect,
      'PayrollStartWeekDay': formProps.PayrollStartWeekDay,
      'PayrollEndWeekDay': formProps.PayrollEndWeekDay,
      'VendorIdTelehealth': formProps.VendorIdTelehealth,
      'VendorNameTelehealth': formProps.VendorNameTelehealth,     
      'IsEnableGenerativeAIFeatures': formProps.IsEnableGenerativeAIFeatures ? true : false,
       

      'OrganizationSubscriptionPlans': [
        {
          'id': this.state.subscriptionPlanId ? this.state.subscriptionPlanId : 0,
          'PlanName': formProps.PlanName,
          'StartDate': formProps.StartDate,
          'PlanType': formProps.PlanType,
          'AmountPerClient': formProps.AmountPerClient,
          'TotalNumberOfClients': formProps.TotalNumberOfClients,
          'OrganizationID': this.state.agencyId ? this.state.agencyId : 0,
        },
      ],
      'OrganizationSMTPDetail': [
        {
          'id': this.state.smtpId ? this.state.smtpId : 0,
          'ServerName': formProps.ServerName,
          'Port': formProps.Port,
          'ConnectionSecurity': formProps.ConnectionSecurity,
          'SMTPUserName': formProps.SMTPUserName,
          'SMTPPassword': formProps.SMTPPassword,
          'OrganizationID': this.state.agencyId ? this.state.agencyId : 0,
        },
      ],
    };
    this.props.clearFieldErrorArray();
    this.props.saveAgencyData(formData);
  }


  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <h2 className="page_title">{this.state.agencyId ? 'Edit Agency Details' : 'Add Agency Details'}</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form mtm-30" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-6 require">
                  <Field
                    name="OrganizationName"
                    type="text"
                    maxLength='60'
                    label="Agency Name"
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Agency Name')}
                    customError={displayCustomError('ORGANIZATIONNAME', this.props.fieldError_ORGANIZATIONNAME)}
                    // customError={(this.props.fieldError && this.props.fieldError.length && this.props.fieldError.some((err) => {
                    //   return (err.statusCode === 409 && err.data.toUpperCase() === 'ORGANIZATIONNAME') ;
                    // })) ? <p>{this.props.fieldError.map((err) => {
                    //   if (err.statusCode === 409 && err.data.toUpperCase() === 'ORGANIZATIONNAME') {
                    //     return `${err.message}`
                    //       ;
                    //   }
                    // })}</p> : undefined}
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
                <div className="col-sm-6 require">
                  <Field
                    id='businessName'
                    name="BusinessName"
                    type="text"
                    maxLength="100"
                    label="Business Name"
                    disabled={this.state.agencyId ? true : false}
                    normalize={isValidName}
                    loader={this.props.loadingField}
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Business Name')}                    
                    customError={displayCustomError('BUSINESSNAME', this.props.fieldError_BUSINESSNAME)}
                    component={renderTextField} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <Field
                    name="Description"
                    type="text"
                    maxLength="1000"
                    label="Description"
                    multiLine={true}
                    // normalize = {isValidNameWithSpace}
                    rowsMax={6}
                    fullWidth={true}
                    component={renderTextArea} />
                  <small className="blackfont font12">{this.props.description ? 1000 - this.props.description.length : 1000} Characters remaining </small>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-8 require">
                  {/* <Field
                    name="Address1"
                    type="text"
                    maxLength="55"
                    label="Address"
                    // normalize = {isValidNameWithSpace}
                    fullWidth={true}
                    component={renderTextField}/> */}
                  {/* {this.state.Address1 !== null || this.state.agencyId === null ? */}
                  <GooglePlaceAutocomplete
                    getFullAddress={this.GetFullAddress}
                    id="Address1"
                    labelText="Address"
                    errorText={this.state.isValidAddress ? '' : 'Please enter address.'}
                    value={this.state.Address1}
                    isFullAddressEmpty={this.IsFullAddressEmpty}
                  // hintText="Enter Address"
                  />
                  {/* : ''} */}
                </div>
                {/* <div className="col-sm-4 require ">
                  <Field
                    name="CountryID"
                    label="Country"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.masterCountryList}
                    component={renderAutoCompleteSingleSelect}/>
                </div> */}
                <div className="col-sm-4">
                  <Field
                    name="ApartmentNumber"
                    type="text"
                    maxLength='15'                    
                    label="Apt/Unit"
                    normalize={isValidApartmentWithSpace}
                    component={renderTextField} />
                </div>
              </div>
              <div className="row">
                {/* <div className="col-sm-4 require ">
                  <Field
                    name="StateID"
                    label="State"
                    handleNewRequest={this.handleNewRequest}
                    disabled = {this.props.CountryID ? false : true}
                    options={this.state.filteredStatesByCountry}
                    component={renderAutoCompleteSingleSelect}/>
                </div> */}
                 <div className="col-sm-4 require">
                  <Field
                    name="City"
                    type="text"
                    maxLength='50'
                    normalize={isValidNameWithSpace}
                    label="City"
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="Zip"
                    type="text"
                    label="Zip Code"
                    maxLength={10}
                    normalize={normalizeZipCode}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="Phone"
                    type="text"
                    label="Phone"
                    maxLength={14}
                    normalize={normalizeMobile}
                    component={renderTextField} />
                </div>
                
              </div>
              <div className="row">
              <div className="col-sm-4 require">
                  <Field
                    name="Email"
                    type="text"
                    label="Email"
                    maxLength="50"
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="Fax"
                    type="text"
                    label="Fax"
                    maxLength={14}
                    normalize={normalizeFax}
                    component={renderTextField} />
                </div>
                <div className="col-4 mt-35">
                  <Field
                    name="IsActive"
                    label="Is Active"
                    component={renderCheckBox}
                    style={stylescss.checkbox}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Agency Logo And Favicon</h3>
                    <i className="flaticon flaticon-picture"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-md-3">
                  <div className="uplaod_pic agencyupload">
                    <FlatButton label="Logo" className="browse" labelPosition="before" style={styles.uploadButton}
                      containerElement="label" fullWidth={true}>
                      <i className="fa fa-cloud-upload fa-2x" aria-hidden="true"></i>
                      {/* <input type="file" style={styles.uploadInput} />*/}
                      <Field
                        name="Logo"
                        type="file"
                        style={styles.uploadInput}
                        component={renderUploadField}
                        onChange={(e) => this._handleImageChange(e)}
                        label="Logo Image" />
                    </FlatButton>
                  </div>
                  <p className="ins_photo">Logo Size (186 x 35)<br />(jpg, jpeg, bmp, png)</p>
                </div>
                <div className="col-sm-6 col-md-3">
                  {this.state.imageLogoPreviewUrl ?
                    <div className="insimage">
                      <img title="Logo Icon" src={this.state.imageLogoPreviewUrl} alt='Error in load!' />
                      <b onClick={(e) => this.handleRemoveImage(e, 'logo')} className="fa fa-times-circle valuefont"
                        aria-hidden="true"></b>
                    </div>
                    : ''}
                </div>
                <div className="col-sm-6 col-md-3">
                  <div className="uplaod_pic agencyupload">
                    <FlatButton label="Favicon Icon" className="browse" labelPosition="before" style={styles.uploadButton}
                      containerElement="label" fullWidth={true}>
                      <i className="fa fa-cloud-upload fa-2x" aria-hidden="true"></i>
                      {/* <input type="file" style={styles.uploadInput} />*/}
                      <Field
                        name="Favicon"
                        type="file"
                        style={styles.uploadInput}
                        component={renderUploadField}
                        onChange={(e) => this._handleImageChange(e)}
                        label="Favicon Image" />
                    </FlatButton>
                  </div>
                  <p className="ins_photo">Favicon Icon Size (16 x 16)<br />(ico, jpg, jpeg, bmp, png)</p>
                </div>
                <div className="col-sm-6 col-md-3">
                  {this.state.imageFaviconPreviewUrl ?
                    <div className="insimage">
                      <img title="Favicon Icon" src={this.state.imageFaviconPreviewUrl} alt='Error in load!' />
                      <b onClick={(e) => this.handleRemoveImage(e, 'favicon')} className="fa fa-times-circle valuefont"
                        aria-hidden="true"></b>
                    </div>
                    : ''}
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="panel_title">
                    <h3>Contact Person Details</h3>
                    <i className="flaticon flaticon-phone-call"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                {/* <div className="col-sm-4 ">
                  <Field
                    name="ContactPersonTitle"
                    label="Title"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.titlePrefixList}
                    component={renderAutoCompleteSingleSelect}/>
                </div> */}
                <div className="col-sm-4 require">
                  <Field
                    name="ContactPersonFirstName"
                    type="text"
                    label="First Name"
                    maxLength="40"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4">
                  <Field
                    name="ContactPersonMiddleName"
                    type="text"
                    label="Middle Name"
                    maxLength="40"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="ContactPersonLastName"
                    type="text"
                    maxLength="40"
                    label="Last Name"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
                {/* <div className="col-sm-3 ">
                  <Field
                    name="ContactPersonMaritalStatus"
                    label="Marital Status"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.maritalStatus}
                    component={renderAutoCompleteSingleSelect}/>
                </div> */}
              </div>
              <div className="row">
                <div className="col-sm-4 require">
                  <Field
                    name="ContactPersonPhoneNumber"
                    type="text"
                    label="Phone Number"
                    maxLength={14}
                    normalize={normalizeMobile}
                    component={renderTextField} />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="panel_title">
                    <h3>Admin Login Details</h3>
                    <i className="flaticon flaticon-padlock"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4 require">
                  <Field
                    name="UserName"
                    type="text"
                    label="User Name"
                    normalize={isValidName}
                    maxLength="50"
                    autoComplete='email'
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'User Name')}
                    customError={displayCustomError('USERNAME', this.props.fieldError_USERNAME)}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="Password"
                    type="password"
                    label="Password"
                    autoComplete='new-password'
                    maxLength="30"
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="ConfirmPassword"
                    type="password"
                    label="Confirm Password"
                    component={renderTextField} />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="panel_title">
                    <h3>Vendor Details</h3>
                    <i className="flaticon flaticon-interface-1"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <Field
                    name="VendorIdDirect"
                    type="text"
                    maxLength="50"
                    label="Vendor Id Direct"
                    normalize={isInteger}
                    component={renderTextField} />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="VendorNameDirect"
                    type="text"
                    maxLength="250"
                    label="Vendor Name Direct"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <Field
                    name="VendorIdIndirect"
                    type="text"
                    maxLength="50"
                    label="Vendor Id Indirect"
                    normalize={isInteger}
                    component={renderTextField} />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="VendorNameIndirect"
                    type="text"
                    maxLength="250"
                    label="Vendor Name Indirect"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <div className="panel_title">
                    <h3>Telehealth Vendor Details</h3>
                    <i className="flaticon flaticon-interface-1"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <Field
                    name="VendorIdTelehealth"
                    type="text"
                    maxLength="50"
                    label="Telehealth Vendor Id "
                    normalize={isInteger}
                    component={renderTextField} />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="VendorNameTelehealth"
                    type="text"
                    maxLength="250"
                    label="Telehealth Vendor Name"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
              </div>
              {/* <div className="row">
                <div className="col-12">
                  <div className="panel_title">
                    <h3>Payroll Week Days</h3>
                    <i className="flaticon flaticon-interface-1"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 require mt-35">
                  <Field
                    name="PayrollStartWeekDay"
                    label="Start Week Day"
                    options={this.state.payrollStartWeekDay}
                    handleNewRequest={this.handleNewRequest}
                    component={renderAutoCompleteSingleSelect} />
                </div>
                <div className="col-sm-6 require mt-35">
                  <Field
                    name="PayrollEndWeekDay"
                    label="End Week Day"
                    disabled={true}
                    options={this.state.payrollEndWeekDay}
                    component={renderAutoCompleteSingleSelect} />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="panel_title">
                    <h3>Subscription Details</h3>
                    <i className="flaticon flaticon-interface-1"></i>
                  </div>
                </div>
              </div> */}
              <div className="row">
                <div className="col-sm-4 require">
                  <Field
                    name="PlanName"
                    type="text"
                    maxLength="100"
                    label="Subscription Plan Name"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="StartDate"
                    placeholder="Subscription Start Date"
                    fullWidth={true}
                    locale="en-US"
                    selected={this.state.StartDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField}
                  />
                </div>
                <div className="col-sm-4 require mt-35">
                  <Field
                    name="PlanType"
                    label="Subscription Plan Type"
                    options={this.state.subscriptionPlanTypes}
                    handleNewRequest={this.handleNewRequest}
                    component={renderAutoCompleteSingleSelect} />
                </div>
              </div>
              <div className="row">
                {/* <div className="col-sm-4 require">
                  <Field
                    name="TotalNumberOfClients"
                    type="text"
                    // maxLength="5"
                    label="Total No. of Clients"
                    normalize={isInteger}
                    component={renderTextField}/>
                </div> */}
                <div className="col-sm-4 require">
                  <Field
                    name="AmountPerClient"
                    type="text"
                    maxLength="8"
                    label="Price Per Client ($)"
                    normalize={normalizeRate}
                    component={renderTextField} />
                </div>

              </div>
              <div className="row">
                <div className="col-12">
                  <div className="panel_title">
                    <h3>Database Details (Microsoft SQL Server)</h3>
                    <i className="flaticon flaticon-technology-2"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className={`col-sm-8 require mt-35 ${this.state.agencyId ? '' : ' mb10'}`}>
                  {!this.state.agencyId ?
                    <Field
                      name="DatabaseDetailId"
                      label="Database Name"
                      handleNewRequest={(input, selectedRecord) => input.onChange(selectedRecord.value)}
                      options={this.state.DatabaseNameList}
                      component={renderAutoCompleteSingleSelect} />
                    : <Field
                      name="DatabaseDetailId"
                      type="text"
                      label="Database Name"
                      disabled={true}
                      normalize={isValidNameWithSpace}
                      component={renderTextField} />}
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="panel_title">
                    <h3>SMTP Details (For Email)</h3>
                    <i className="flaticon flaticon-email"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4 require">
                  <Field
                    name="ServerName"
                    type="text"
                    label="Server Name"
                    maxLength="50"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="Port"
                    type="text"
                    maxLength="5"
                    label="Port"
                    normalize={isInteger}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="ConnectionSecurity"
                    type="text"
                    normalize={isValidNameWithSpace}
                    maxLength="50"
                    label="Connection Security"
                    component={renderTextField} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4 require">
                  <Field
                    name="SMTPUserName"
                    type="text"
                    label="Username"
                    maxLength="50"
                    normalize={isValidName}
                    component={renderTextField} />
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="SMTPPassword"
                    type='password'
                    // type={this.state.showPassword ? 'text' : 'password'}
                    autoComplete='new-password'
                    maxLength="50"
                    label="Password"
                    component={renderTextField} />
                  {/* <span className="eyeicon">{this.state.showPassword === false ?
                    <i onClick = {(e) => this.setState({ showPassword: true })} className="fa fa-eye" aria-hidden="true"></i> :
                    <i onClick = {(e) => this.setState({ showPassword: false })} className="fa fa-eye-slash" aria-hidden="true"></i>
                  }</span> */}
                </div>
                <div className="col-sm-4 require">
                  <Field
                    name="SMTPConfirmPassword"
                    type='password'
                    // type={this.state.showPassword ? 'text' : 'password'}
                    autoComplete='new-password'
                    maxLength="50"
                    label="Confirm Password"
                    component={renderTextField} />
                </div>

              </div>

              <div className="row">
                <div className="col-12">
                  <div className="panel_title">
                    <h3>Other Settings</h3>
                    <i className="flaticon flaticon-email"></i>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4 mt-35">
                  <Field
                    name="IsEnableGenerativeAIFeatures"
                    label="Enable Generative AI Features"
                    component={renderCheckBox}
                    style={stylescss.checkbox}
                  />
                </div>
              </div>
              
              <div className="row">
                <div className="col-sm-12 pt20 btn_rt">
                  <CancelButton className="mr-15" onTouchTap={this.handleCancel} />
                  {this.props.fieldErrorLoading ? <SubmitButtonDisabled label='Save' /> : <SubmitButton label="Save" />}
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    );
  }
};
const selector = formValueSelector('AgencySetupForm');
function mapStateToProps(state, ownProps) {
  // console.log(state.agency);
  let maritalStatus = [];
  if (state.agency.master_data && state.agency.master_data.masterMaritalStatus) {
    maritalStatus = state.agency.master_data.masterMaritalStatus;
  }
  let orgDb = [];
  if (state.agency.master_data.organizationDatabaseDetail && state.agency.master_data.organizationDatabaseDetail.length) {
    orgDb = state.agency.master_data.organizationDatabaseDetail.map((Obj) => {
      return {
        'id': Obj.id,
        'value': Obj.databaseName,
      };
    });
  }

  let initialData = {
    IsActive: true,
  };
  // let initialData = {
  //   CountryID: 1,
  // };
  if (ownProps.match.params.id && state.agency.agencyData.data) {
    let agency_data = state.agency.agencyData.data;
    if (agency_data.id) {
      let subscriptionPlanData = agency_data.organizationSubscriptionPlans.length ? agency_data.organizationSubscriptionPlans[0] : {};
      let smtpData = agency_data.organizationSMTPDetail.length ? agency_data.organizationSMTPDetail[0] : {};
      // console.log(subscriptionPlanData, smtpData);
      // console.log('agency_data...........',agency_data);
      initialData = {
        id: agency_data.id,
        OrganizationName: agency_data.organizationName,
        BusinessName: agency_data.businessName,
        Description: agency_data.description,
        Address1: agency_data.address1,
        City: agency_data.city,
        // StateID: agency_data.stateID,
        // CountryID: agency_data.countryID,
        Zip: agency_data.zip,
        Phone: agency_data.phone,
        Fax: agency_data.fax,
        Email: agency_data.email,
        // logo
        // favicon
        ContactPersonFirstName: agency_data.contactPersonFirstName,
        ContactPersonMiddleName: agency_data.contactPersonMiddleName,
        ContactPersonLastName: agency_data.contactPersonLastName,
        ContactPersonPhoneNumber: agency_data.contactPersonPhoneNumber,
        // ContactPersonMaritalStatus: agency_data.contactPersonMaritalStatus,
        UserName: agency_data.userName,
        Password: agency_data.password,
        ConfirmPassword: agency_data.password,
        DatabaseDetailId: agency_data.databaseName,
        IsActive: agency_data.isActive,
        Latitude: agency_data.latitude,
        Longitude: agency_data.longitude,
        ApartmentNumber: agency_data.apartmentNumber,

        VendorIdDirect: agency_data.vendorIdDirect,
        VendorIdIndirect: agency_data.vendorIdIndirect,
        VendorNameDirect: agency_data.vendorNameDirect,
        VendorNameIndirect: agency_data.vendorNameIndirect,
        PayrollStartWeekDay: agency_data.payrollStartWeekDay,
        PayrollEndWeekDay: agency_data.payrollEndWeekDay,

        VendorIdTelehealth: agency_data.vendorIdTelehealth,
        VendorNameTelehealth: agency_data.vendorNameTelehealth,
        IsEnableGenerativeAIFeatures: agency_data.isEnableGenerativeAIFeatures,

        // For Subscription Plans
        subscriptionPlanId: subscriptionPlanData.id,
        PlanName: subscriptionPlanData.planName,
        StartDate: subscriptionPlanData.startDate,
        PlanType: subscriptionPlanData.planType,
        AmountPerClient: subscriptionPlanData.amountPerClient ? showNormalizedRate(subscriptionPlanData.amountPerClient) : 0,
        TotalNumberOfClients: subscriptionPlanData.totalNumberOfClients,

        // For SMTP Details
        smtpId: smtpData.id,
        ServerName: smtpData.serverName,
        Port: smtpData.port,
        ConnectionSecurity: smtpData.connectionSecurity,
        SMTPUserName: smtpData.smtpUserName,
        SMTPPassword: smtpData.smtpPassword,
        SMTPConfirmPassword: smtpData.smtpPassword,
      };
    }
  }

  let fieldError_ORGANIZATIONNAME = null;
  let fieldError_BUSINESSNAME = null;
  let fieldError_USERNAME = null;
  
  if (state.appConfig && state.appConfig.fieldError) {
    fieldError_ORGANIZATIONNAME = state.appConfig.fieldError.filter((obj, i) =>  obj.data === "ORGANIZATIONNAME");    
    fieldError_BUSINESSNAME = state.appConfig.fieldError.filter((obj, i) =>  obj.data === "BUSINESSNAME");    
    fieldError_USERNAME = state.appConfig.fieldError.filter((obj, i) =>  obj.data === "USERNAME");    
  }

  return {
    master_data: state.agency.master_data,
    maritalStatus: maritalStatus,
    organizationDatabase: orgDb,
    fieldError_ORGANIZATIONNAME: fieldError_ORGANIZATIONNAME,
    fieldError_BUSINESSNAME: fieldError_BUSINESSNAME,
    fieldError_USERNAME: fieldError_USERNAME,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialData,
    agencyData: state.agency.agencyData.data,
    is_agency_exist: state.agency.isExist,
    loadingField: state.agency.loadingField,
    description: selector(state, 'Description'),
    // CountryID: selector(state, 'CountryID'),
  };

};

AgencySetup = reduxForm({
  form: 'AgencySetupForm',
  validate,
  // asyncValidate,
  // asyncBlurFields: ['OrganizationName'],
  enableReinitialize: true,
})(AgencySetup);

export default connect(mapStateToProps, { checkFieldExistenceInMasterDB, clearFieldErrorArray, getAgencyDataById, saveAgencyData, isAgencyExist, getMasterData })(AgencySetup);



// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/ManageAgency/components/agencySetup.js